import { CUSTOMER_BILLING_SETUP_HREF } from "./billingNavigation";

export type SettingsDestination = {
  sectionId: string;
  label: string;
  href: string;
};

/**
 * Customer-facing Settings destinations used by alerts, onboarding, and other
 * generated links. Compatibility redirects for retired URLs live in the client
 * router and must not be used to generate new links.
 */
export const SETTINGS_DESTINATIONS = {
  businessInfo: {
    sectionId: "business-info",
    label: "Business Info",
    href: "/dashboard?settings=business-info",
  },
  calendar: {
    sectionId: "business-info",
    label: "Calendar",
    href: "/dashboard?settings=business-info&settingsTab=calendar",
  },
  importExport: {
    sectionId: "business-info",
    label: "Import/Export",
    href: "/dashboard?settings=business-info&settingsTab=data",
  },
  domainEmail: {
    sectionId: "domain-email",
    label: "Domain & Email",
    href: "/dashboard?settings=domain-email",
  },
  clientBilling: {
    sectionId: "client-billing",
    label: "Billing",
    href: CUSTOMER_BILLING_SETUP_HREF,
  },
  billing: {
    sectionId: "account-info",
    label: "Billing",
    href: "/dashboard?settings=account-info&settingsTab=billing",
  },
  help: {
    sectionId: "help",
    label: "Help",
    href: "/dashboard?settings=help",
  },
} as const satisfies Record<string, SettingsDestination>;

export function settingsDestinationUrl(
  destination: SettingsDestination,
  origin?: string | null,
): string {
  const normalizedOrigin = origin?.trim().replace(/\/+$/, "");
  return normalizedOrigin ? `${normalizedOrigin}${destination.href}` : destination.href;
}
